import type { FieldValues } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';

import type { FieldBaseProps } from './types';

type Props<T extends FieldValues> = FieldBaseProps<T> & {
  type?: 'text' | 'email' | 'password' | 'url' | 'tel' | 'time';
  placeholder?: string;
  autoComplete?: string;
};

export function FormTextField<T extends FieldValues>({
  name,
  label,
  description,
  required,
  disabled,
  className,
  type = 'text',
  placeholder,
  autoComplete,
}: Props<T>) {
  const { control } = useFormContext<T>();
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className={className}>
          {label ? (
            <FormLabel>
              {label}
              {required ? <span aria-hidden="true"> *</span> : null}
            </FormLabel>
          ) : null}
          <FormControl>
            <Input
              type={type}
              placeholder={placeholder}
              autoComplete={autoComplete}
              disabled={disabled}
              {...field}
              value={field.value ?? ''}
            />
          </FormControl>
          {description ? <FormDescription>{description}</FormDescription> : null}
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
